const sessionKey = 'materials-colors';
let selectOrderMap = {}
let colors = []

async function getMaterialsAndColors(){
  const sessionData = getSessionData(sessionKey)
  if(sessionData){
    const valueData = sessionData.value
    if(valueData.status === 'success' && valueData.colors && valueData.materials){
      colors = mapColors(valueData.colors);
      selectOrderMap = mapMaterials(valueData.materials);
    } else {
      await fetchAndSetMaterialsAndColors();
    }
  } else {
    await fetchAndSetMaterialsAndColors();
  }
}

function setSessionData(key, value) {
  const now = new Date().getTime(); 
  const data = {
    value: value,
    timestamp: now 
  };
  sessionStorage.setItem(key, JSON.stringify(data));
}

function getSessionData(key) {
  const dataString = sessionStorage.getItem(key);
  if (!dataString) {
    return null; 
  }

  const data = JSON.parse(dataString);
  const now = new Date().getTime();
  const one_hour = 3600000;
  
  const timeElapsed = now - data.timestamp;

  if (timeElapsed > one_hour) {
    sessionStorage.removeItem(key); 
    return null; 
  }

  return {
    value: data.value,
    timeElapsed: timeElapsed 
  };
}

async function fetchAndSetMaterialsAndColors() {
  const url = "https://juju-brain-server.cr.juju.business/hollyPalm/materials-and-colors";
  const response = await fetch(url);
  const result = await response.json()

  if(result.status === 'success' && result.colors && result.materials){
    setSessionData(sessionKey, result)
    colors = mapColors(result.colors);
    selectOrderMap = mapMaterials(result.materials);
  }
}

function mapColors(colors) {
  return colors.reduce((map, item) => {
    map[item.sku] = {
      tr: item.title,
      en: item.titleEn,
      sku: item.sku,
      code: item.colorCode,
      order: item.order
    };
    return map;
  }, {});
}

function mapMaterials(materials) {
  return materials.reduce((map, item) => {
    map[item.sku] = {
      sku: item.sku,
      tr: item.title,
      metafield: item.metafield,
      en: item.titleEn,
      order: item.order
    };
    return map;
  }, {});
}

function processData(data) {
  return data.map(each => {
    const [sku, color] = each.split(':');
    const {propertyName, colorName, colorCode} = getNameAndColor(sku, color);
    if(!propertyName || !colorName || !colorCode) return;

    return `
      <div class="properties-cart">
        <div style="background:${colorCode};" class="background-rounded"></div>
        <span>${propertyName}:</span>
        <span> ${colorName}</span>
      </div>
    `;
  }).join('');
}

function getNameAndColor(sku, color){
  const selectedProperty = selectOrderMap[sku];
  const selectedColor = colors[color];
  if(!selectedProperty || !selectedColor) return

  const propertyName = selectedProperty[window.pdp.shopLocale];
  const colorName = selectedColor[window.pdp.shopLocale];
  const colorCode = selectedColor.code;
  return {
    propertyName,
    colorName,
    colorCode
  }
}

async function handleBundleComponents() {
  const componentContainers = document.querySelectorAll('[data-component-id]');
  
  componentContainers.forEach(container => {
    const skuElement = container.querySelector('[data-component-sku]');
    if (!skuElement) return;
    
    const sku = skuElement.getAttribute('data-component-sku');
    
    // SKU'yu parçalara ayır (örn: "CBM-589-S-M:G-C:SC-E:MIX")
    let skuParts = sku.split('-');
    const baseSkuPart = skuParts.slice(0, 3).join('-'); // "CBM-589-S"
    
    // Materyal ve renk bilgilerini al
    const materialParts = skuParts.slice(3).join('-'); // "M:G-C:SC-E:MIX"
    if (!materialParts) return;
    
    const data = materialParts.split('-');
    const processedHtml = processData(data);
    
    skuElement.innerHTML = processedHtml;
  });
  processAttributeInputs();
}

function processAttributeInputs(){
  const processableAttributes = document.querySelectorAll('[data-bundle-process-sku]');
  if(!processableAttributes || !processableAttributes.length) return;

  processableAttributes.forEach(input => {
    let sku;
    let value = input.value; // CBM-589-S-M:G-C:SC-E:MIX_RingSize:44,3mm
    let rs;
    if(value.includes('_')){
      const [sku, ringSize] = value.split('_');
      value = sku;
      rs = ringSize; // RingSize: 44,3mm
    }
    let skuParts = value.split('-');
    const baseSkuPart = skuParts.slice(0, 3).join('-'); // "CBM-589-S"
    sku = baseSkuPart;
    
    const materialParts = skuParts.slice(3) // "M:G-C:SC-E:MIX"
    let finalValue = ''
    materialParts.forEach((part, index) => {
      const [property, color] = part.split(':');
      const {propertyName, colorName} = getNameAndColor(property, color);
      if(!propertyName || !colorName) return;

      finalValue += `${propertyName}:${colorName}`;
      if(index !== materialParts.length - 1) finalValue += ',';
    })
    input.value = rs ? `${sku},${finalValue},${rs}` : `${sku},${finalValue}`;
  });
}

async function handleCartPageVariants() {
  await getMaterialsAndColors();
  
  // Normal ürünler için işlem
  const currentSkus = Array.from(document.querySelectorAll('[data-variantsku]')).map(elem => elem.innerText);
  const allVars = document.querySelectorAll('[data-vars]');

  const processedData = Array.from(allVars).map((vars, index) => {
    let skuData = vars.getAttribute('data-vars');
    if (skuData.includes(currentSkus[index])) {
      let splitData = skuData.split(currentSkus[index]);
      let slicedData = splitData[1];
      let finalSkuData = slicedData.slice(1);
      skuData = finalSkuData;
    } else {
      let skuParts = currentSkus[index].split('-');
      let skuPrefix = skuParts[0] + '-' + skuParts[1];
      let skuRegex = new RegExp(skuPrefix + '-\\w+');
      let match = skuData.match(skuRegex);
      if (match) {
        let splitData = skuData.split(match[0]);
        let slicedData = splitData[1];
        let finalSkuData = slicedData.slice(1);
        skuData = finalSkuData;
      }
    }
    let splitData = skuData.split(currentSkus[index]);
    let slicedData = splitData[0];
    let finalSkuData = slicedData.slice(1);
    const data = skuData.split('-');
    return processData(data);
  });

  allVars.forEach((vars, index) => {
    vars.classList.remove('hidden');
    vars.innerHTML = processedData[index];
  });

  // Bundle ürünler için işlem
  await handleBundleComponents();

}

if (window.pdp.pageType === 'cart') {
  handleCartPageVariants();
} 